import { render, staticRenderFns } from "./UserCard.vue?vue&type=template&id=46633452&lang=pug&"
import script from "./UserCard.vue?vue&type=script&lang=ts&"
export * from "./UserCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports